// extracted by mini-css-extract-plugin
export var body = "LineItem-module--body--MGrgw";
export var item = "LineItem-module--item--zUCi4";
export var line = "LineItem-module--line--Y0VEP";
export var tags = "LineItem-module--tags--HQ1Dz";